











import DocumentLink from '@/components/DocumentLink'

export default 
    name: 'NotFound'

    components:
        DocumentLink: DocumentLink

